export default __webpack_public_path__ + "static/media/MRI.508223cf.svg";